
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Shendur lal chadhayo" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Shendur lal chadhayo" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shendur Lal Chadhayo, Ganesh Aarti Lyrics, Ganpati Aarti, shendur lal chadhayo lyrics english, shendur lal chadhayo lyrics marathi, श्री गणपति जी की आरती, शेंदुर लाल चढ़ायो अच्छा गजमुखको'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Ganpati Aarti, Shendur Lal Chadhayo, Ganesh Aarti Lyrics, Ganpati Bhajan, Lord Ganesha Songs, Marathi Aarti, Devotional aarti, shendur lal chadhayo lyrics english, shendur lal chadhayo lyrics marathi, श्री गणपति जी की आरती, शेंदुर लाल चढ़ायो अच्छा गजमुखको'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/ganpati.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/ganpati.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shendur lal chadhayo | Ganpati Aarti - शेंदुर लाल चढ़ायो (गणपती आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/ganpati"
        },
        "headline": "Shendur lal chadhayo - शेंदुर लाल चढ़ायो (गणपती आरती)",
        "name" : "Shendur Lal Chadhayo - Ganpati Aarti",
        "description": "Explore the full lyrics of Aarti 'Shendur lal chadhayo' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/ganpati.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  